// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"846":"technical","981":"rules"}[chunkId] + "." + {"846":"1b4c1645","981":"7464629c"}[chunkId] + ".css";
};